// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__RsSn9","inputWrap":"CustomTip_inputWrap__1Cf0C"};